export enum Tempo {
  Normal = 'Normal',
  SlowDown = 'Slow',
  SpeedUp = 'Speed',
}
